import { Injectable } from '@angular/core';
import { Logger, LoggerFactory } from './logger.service';
import { ENVIRONMENT } from 'app/environment/environment';
import { CurrentContextStorage } from './current-context-storage';

@Injectable({ providedIn: 'root' })
export class StorageCurrentContextService {
  private logger: Logger;
  private readonly localStorageKey = ENVIRONMENT.cookieNames.currentContext;

  constructor(loggerFactory: LoggerFactory) {
    this.logger = loggerFactory.get('StorageCurrentContextService');
  }

  public createOrUpdate(update: Partial<CurrentContextStorage>): void {
    const context: CurrentContextStorage = { ...this.get(), ...update } as CurrentContextStorage;
    localStorage.setItem(this.localStorageKey, JSON.stringify(context));
  }

  public get(): CurrentContextStorage | null {
    try {
      const stored = localStorage.getItem(this.localStorageKey);
      if (!stored) {
        return null;
      }
      return JSON.parse(stored) as CurrentContextStorage;
    } catch (error) {
      this.logger.error(`Could not get from localStorage. Error: ${JSON.stringify(error)}`);
      return null;
    }
  }

  public remove(): void {
    try {
      localStorage.removeItem(this.localStorageKey);
    } catch (error) {
      this.logger.error(`Could not remove from localStorage. Error: ${JSON.stringify(error)}`);
    }
  }
}
